import { Tabs, Tooltip } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { getOverTimeData, postSingleBuyApi, fetchInsMonitorSearch } from '@/lib/service';
import style from './index.module.less';
import { RightOutlined, MinusCircleOutlined, PlusCircleFilled } from '@ant-design/icons';
import classnames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { BuyoutListModel, SingleInfo } from '@/types/home';
import { getCurrencyInfo } from '@/components/Plan/LangCurrencyEnum';
const PURCHASED = 1;
const ActiveAccountModal: React.FC<any> = () => {
  const { t } = useTranslation('common');
  const [allDataList, setAllDataList] = useState<SingleInfo[]>([]);
  const [newMounse, setNowMounse] = useState<any>({});
  const [selectAllReport, setSelectAllReport] = useState<BuyoutListModel[]>([]); //右侧内容选中
  const [step, setStep] = useState<number>(0);
  const scrollDiv = useRef(null);
  const router = useRouter();
  const [routerInfo] = useState<any>({
    avatar: router.query.avatar,
    identification: router.query.identification,
    name: router.query.name,
    id: router.query.identification,
  });

  // 选中
  const hanleSelectRow = (item: any) => {
    if (item.status == 1) {
      return;
    }
    let temp = selectAllReport.filter((row) => row.begin_time == item.begin_time);
    if (temp.length == 0) {
      setSelectAllReport([item, ...selectAllReport]);
    } else {
      let arr = selectAllReport.filter((row) => row.begin_time != item.begin_time);
      setSelectAllReport(arr);
    }
  };
  // 是否选中判断
  const isSelect = (item: any) => {
    let temp = selectAllReport.filter((row) => row.begin_time === item.begin_time);
    return temp.length > 0;
  };
  // 删选
  const handleDeleteItem = (item: any) => {
    let temp = selectAllReport.filter((row) => row.begin_time != item.begin_time);
    setSelectAllReport(temp);
  };
  const getData = () => {
    getOverTimeData(routerInfo.identification || routerInfo.id).then((res) => {
      if (res?.code === 0) {
        const temp = res.data.findLastIndex((item) => item.buyout_list.some((v) => v.status !== PURCHASED));
        setAllDataList(res.data);
        setNowMounse(res.data[temp < 0 ? res.data.length - 1 : temp]);
        setStep(temp < 0 ? res.data.length - 1 : temp);

        if (res.data?.length > 0) {
          var tempTotal = 0;
          var tempList: any[] = [];
          for (let i = res.data.length - 1; i >= 0; i--) {
            const element = res.data[i]?.buyout_list;

            for (let j = element?.length - 1; j >= 0; j--) {
              const subElement = element[j];
              if (subElement?.status !== 1 && tempTotal < 6) {
                tempList.push(subElement);
                // hanleSelectRow(subElement)
                tempTotal += 1;
                if (tempTotal >= 6) {
                  break;
                }
              }
            }
          }
          setSelectAllReport(tempList);
        }
      }
    });
  };
  // 向右滚动
  const handleClickRight = () => {
    scrollDiv.current.scrollLeft = scrollDiv.current.scrollLeft + 20;
  };

  let titleMap = new Map([
    [0, t('First Activity Report')],
    [1, t('Second Activity Report')],
    [2, t('Third Activity Report')],
    [3, t('Fourth Activity Report')],
    [4, t('Fifth Activity Report')],
  ]);

  useEffect(() => {
    setNowMounse(allDataList[step]);
  }, [step]);
  useEffect(() => {
    getData();
  }, []);
  const [myAvatar, setmyAvatar] = useState('');
  useEffect(() => {
    if (!routerInfo?.avatar || routerInfo?.avatar == 'undefined') {
      fetchInsMonitorSearch(routerInfo.name, undefined).then((res: any) => {
        setmyAvatar(res.data[0].profile_pic_url);
      });
    }
  }, []);

  // 购买
  const handlePostBal = () => {
    if (selectAllReport.length == 0) {
      return;
    }
    let arr = selectAllReport.map((item) => ({
      begin_date: item.begin_time,
      end_date: item.end_time,
      record_id: item.record_id,
    }));
    let params = {
      identification: routerInfo.identification || routerInfo.id,
      params: arr,
    };
    postSingleBuyApi(params).then(async (res) => {
      // window.open(res.data?.pay_link, '_blank');
      window.location.href = res.data?.pay_link;
    });
  };
  //  可购买报告总数
  const reportTotal = useMemo(() => {
    return allDataList.reduce((acc, item) => {
      const falseCount = item.buyout_list.filter((b) => !b.status).length;
      return acc + falseCount;
    }, 0);
  }, [allDataList]);

  const handleStep = (step: string) => {
    setStep(+step);
  };

  // 点击加号;
  const handlePlus = (e: any) => {
    e.stopPropagation();
    const allData: BuyoutListModel[] = allDataList.flatMap((current) =>
      current.buyout_list
        .filter((item) => !item.status)
        .filter((item) => !selectAllReport.some((v) => v.begin_time === item.begin_time))
    );
    if (!allData.length) return;
    setSelectAllReport([allData[allData.length - 1], ...selectAllReport]);
  };
  // 点击减号
  const handleMinus = (e: any) => {
    e.stopPropagation();
    if (!selectAllReport.length) return;
    const sortData = selectAllReport.sort((a, b) => +new Date(a.begin_time) - +new Date(b.begin_time));

    setSelectAllReport(selectAllReport.filter((item) => item.begin_time !== sortData[0].begin_time));
  };

  const [browserLanguage, setBrowserLanguage] = useState<string | null>(null);

  useEffect(() => {
    // 检查 navigator 对象是否存在于客户端
    if (typeof window !== 'undefined' && navigator.language) {
      // 获取浏览器的首选语言
      const browserLanguage = navigator.language;
      const prefix = browserLanguage.split('-')[0];
      // 设置语言前缀
      setBrowserLanguage(prefix);
    }
  }, []);
  const currencyInfo = getCurrencyInfo(browserLanguage);

  return (
    <div className={style.payPageCon}>
      <div className={style.payBtn}>
        <div className={style.btn} onClick={handlePostBal}>
          <MinusCircleOutlined className={style.btnIcon} onClick={handleMinus} />
          <div className={style.mainContent}>
            <span className={style.moneyTotal}>${(currencyInfo.price * selectAllReport.length).toFixed(2)}</span>
            <span className={style.reportTotal}>
              {selectAllReport.length} {t('report')}
            </span>
          </div>
          <PlusCircleFilled className={style.btnIcon} onClick={handlePlus} />
        </div>
      </div>
      <div className={style.header}>{t('RequestRetrospectiveDatafor')}</div>
      <div className={style.avatarAndDesc}>
        <div className={style.avatar}>
          <img
            src={routerInfo?.avatar && routerInfo?.avatar != 'undefined' ? routerInfo?.avatar : myAvatar}
            alt={routerInfo?.name || routerInfo?.media_name}
          />
        </div>
        <div className={style.name}>
          <span>{routerInfo?.name || routerInfo?.media_name}</span>
        </div>
      </div>
      <div className={style.desc}>
        {t('You can access')} <span>{t('up to 36 past reports')}.</span>
        {t('Naturally, longer tracking periods provide better insights')}
        <div>{t('P.S. Most users choose the 6-week report')}</div>
      </div>
      <div className={style.starTip}>
        <Tooltip
          placement="bottom"
          color={'#fff'}
          title={<p style={{ color: '#000', padding: '4px' }}>{t('Star tip')}</p>}
        >
          <span className={style.tipText}>{t('Learn about report delivery times')}</span>
        </Tooltip>
      </div>
      <div className={style.tabStep}>
        <Tabs
          activeKey={step + ''}
          items={allDataList.map((item, index) => {
            return { key: index + '', label: item.month };
          })}
          onTabClick={handleStep}
        />
      </div>
      <div className={style.selectReport}>
        {newMounse?.buyout_list &&
          newMounse?.buyout_list.map((item: any, idx: number) => (
            <div
              key={idx}
              onClick={() => hanleSelectRow(item)}
              className={classnames(style.leftListItem, isSelect(item) ? style.leftListItemAc : '')}
            >
              <div className={style.dateContent}>
                <div style={{ color: item.status == 1 ? 'rgba(217, 217, 217, 1)' : '' }} className={style.firstRow}>
                  {titleMap.get(idx)}
                </div>
                <div className={style.secondRow} style={{ color: item.status == 1 ? 'rgba(217, 217, 217, 1)' : '' }}>
                  <span>{item.begin_time}</span>
                  <span>-</span>
                  <span>{item.end_time}</span>
                </div>
              </div>
              {item.status == 1 && <div className={style.purchased}>{t('Purchased')}</div>}
              {item.has_data ? <img src="/images/starInfo/yellowStar.webp" alt="" /> : ''}
            </div>
          ))}
      </div>
      <div className={style.reportStar}>{t('Please note that psat reports do not include Stories & Highlights')}</div>
      <div className={style.selectHead}>
        {t('Selected')} <span>{selectAllReport.length}</span> / {reportTotal + ' '} {t('reports')}
      </div>
      <div className={style.right}>
        <div style={{ position: 'relative' }}>
          <div className={style.handleSelect} ref={scrollDiv}>
            {selectAllReport?.map((item, idx) => (
              <div
                key={idx}
                className={style.item}
                onClick={() => {
                  handleDeleteItem(item);
                }}
              >
                {item.begin_time} <span>-</span> {item.end_time}
                {item.has_data ? (
                  <img className={style.yellowStar} src="/images/starInfo/yellowStar.webp" alt="" />
                ) : (
                  ''
                )}
              </div>
            ))}
          </div>
          <div className={style.iconRight} onClick={() => handleClickRight()}>
            <RightOutlined style={{ color: '#725CFF', marginTop: '21px' }} />
          </div>
        </div>
      </div>
      <div className={style.result}>
        <div>
          {currencyInfo.symbol}
          {currencyInfo.price} / {t('reports')} x {selectAllReport.length}
        </div>
        <div>${(currencyInfo.price * selectAllReport.length).toFixed(2)}</div>
      </div>
    </div>
  );
};

const Index = (data: any) => {
  return <ActiveAccountModal {...data}></ActiveAccountModal>;
};
export default Index;
